import React, {useState} from 'react'
import {
    Card,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Row,
    Col,
  } from "reactstrap";

import DataImportPage from '../DataImportPage'
import MainFours from './editFours/MainFours';
import MainOPK from './editOPK/MainOPK';
import {connect} from 'react-redux';
import {getCurrentUser} from 'actions/userActions';
import { ToastContainer, toast } from 'react-toastify';



const MainEdit = ({getCurrentUser}) => {
      const [horizontalTabs, setHorizontalTabs] = useState("mainOPK");
      React.useEffect(()=>{
        getCurrentUser()
    },[])
    const notify = (txt, color = "error") => toast[color](txt, { position: "bottom-right" });

    return (
        <DataImportPage>
            <Row>
            <Col md="12">
            <Card>
              <CardBody>
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <Nav id="tabs" role="tablist" tabs>
                      
                      <NavItem>
                        <NavLink style={{cursor: 'pointer'}}
                          aria-expanded={horizontalTabs === "mainOPK"}
                          data-toggle="tab"
                          // href="#pablo"
                          role="tab"
                          tabIndex={'0'}
                          className={horizontalTabs === "mainOPK" ? "active importPanel" : ""}
                          onClick={() => setHorizontalTabs("mainOPK")}
                             onKeyDown={(e) => {
                                 if (e.key === 'Enter') {
                                     setHorizontalTabs("mainOPK")
                                 }
                             }}
                        >
                          Edycja kont zespołu "5"
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink style={{cursor: 'pointer'}}
                          aria-expanded={horizontalTabs === "mainFours"}
                          data-toggle="tab"
                          // href="#pablo"
                          role="tab"
                          tabIndex={'0'}
                          className={horizontalTabs === "mainFours" ? "active importPanel" : ""}
                          onClick={() => setHorizontalTabs("mainFours")}
                             onKeyDown={(e) => {
                                 if (e.key === 'Enter') {
                                     setHorizontalTabs("mainFours")
                                 }
                             }}
                        >
                            Edycja kont rodzajowych zespołu "4"
                        </NavLink>
                      </NavItem>
                      
                    </Nav>
                  </div>
                </div>
                <TabContent
                  className="text-center"
                  id="my-tab-content"
                  activeTab={horizontalTabs}
                >
                  <TabPane tabId="mainOPK" role="tabpanel">
                      <MainOPK notify={notify} />
                  </TabPane>

                  <TabPane tabId="mainFours" role="tabpanel">
                      <MainFours notify={notify}/>
                  </TabPane>

                </TabContent>
              </CardBody>
            </Card>
              
            
            </Col>
        </Row>
            
        </DataImportPage>
    )
}
const mapStateToProps = (state) => ({
  currentUser: state.UserReducer.currentUser

});
export default connect(mapStateToProps,{getCurrentUser} )(MainEdit)
